var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share"},[_c('img',{staticClass:"share_bgc",attrs:{"src":_vm.accountInfo.shareChangePointbgUrl}}),(_vm.accountInfo.shareChangePointbgUrl)?_c('img',{staticClass:"share_btn",attrs:{"src":require("@/assets/images/account/share_btn.png")},on:{"click":_vm.share}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }